import {
    apiRequest,
    kriteriaSkpTunsusDetail,
    kriteriaSkpTunsusUpdate
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunsusService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", kriteriaSkpTunsusDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", kriteriaSkpTunsusUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository